import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";
import { UpdateSupplierInvoiceLineDto } from "./update-supplier-invoice-line.dto";
import { UpdateSupplierInvoiceTaxLineDto } from "./update-supplier-invoice-tax-line.dto";

export class UpdateSupplierInvoiceDto {
  @Expose()
  numeration?: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date?: Date;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  expirationDate?: Date;

  @Expose()
  @Transform(({ value }) => toCents(value))
  subtotalAmount?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  totalTaxAmount?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  totalAmount?: number;

  @Expose()
  cif?: string;

  @Expose()
  companyId?: string;

  @Expose()
  supplierId?: string;

  @Expose()
  @Type(() => UpdateSupplierInvoiceLineDto)
  lines?: UpdateSupplierInvoiceLineDto[];

  @Expose()
  @Type(() => UpdateSupplierInvoiceTaxLineDto)
  taxLines?: UpdateSupplierInvoiceTaxLineDto[];
}
